__turbopack_context__.v({
  "banner": "khwYaa_banner",
  "complianceFeatures": "khwYaa_complianceFeatures",
  "container": "khwYaa_container",
  "contentColumn": "khwYaa_contentColumn",
  "contentRow": "khwYaa_contentRow",
  "dataEncryption": "khwYaa_dataEncryption",
  "ferpaCompliance": "khwYaa_ferpaCompliance",
  "freeBox": "khwYaa_freeBox",
  "gdprCompliance": "khwYaa_gdprCompliance",
  "h3__tG3VF": "khwYaa_h3__tG3VF",
  "h3__wZOiz": "khwYaa_h3__wZOiz",
  "h3__wadPt": "khwYaa_h3__wadPt",
  "h3__xYkh6": "khwYaa_h3__xYkh6",
  "h3__xwFIb": "khwYaa_h3__xwFIb",
  "h4": "khwYaa_h4",
  "heading": "khwYaa_heading",
  "hipaa": "khwYaa_hipaa",
  "learnMore": "khwYaa_learnMore",
  "line": "khwYaa_line",
  "links": "khwYaa_links",
  "otherComplianceFeatures": "khwYaa_otherComplianceFeatures",
  "ourCommitmentToSecurityAndCompliance": "khwYaa_ourCommitmentToSecurityAndCompliance",
  "p___1TuOq": "khwYaa_p___1TuOq",
  "p___7QpMb": "khwYaa_p___7QpMb",
  "p__akmzF": "khwYaa_p__akmzF",
  "p__bn0IB": "khwYaa_p__bn0IB",
  "p__cNVn1": "khwYaa_p__cNVn1",
  "p__d74ON": "khwYaa_p__d74ON",
  "p__dlPc6": "khwYaa_p__dlPc6",
  "p__eghx": "khwYaa_p__eghx",
  "p__eheDc": "khwYaa_p__eheDc",
  "p__fbyef": "khwYaa_p__fbyef",
  "p__k2Ki5": "khwYaa_p__k2Ki5",
  "p__mA7JO": "khwYaa_p__mA7JO",
  "p__rCtc5": "khwYaa_p__rCtc5",
  "p__s0ONe": "khwYaa_p__s0ONe",
  "p__wShDd": "khwYaa_p__wShDd",
  "p__y9FyW": "khwYaa_p__y9FyW",
  "rawLi___0Mecu": "khwYaa_rawLi___0Mecu",
  "rawLi__g6I15": "khwYaa_rawLi__g6I15",
  "rawLi__gs7WM": "khwYaa_rawLi__gs7WM",
  "rawLi__jZLem": "khwYaa_rawLi__jZLem",
  "rawLi__lADdZ": "khwYaa_rawLi__lADdZ",
  "rawLi__tcrB": "khwYaa_rawLi__tcrB",
  "rawLi__yogGb": "khwYaa_rawLi__yogGb",
  "rawUl__dky": "khwYaa_rawUl__dky",
  "rawUl__eDtR8": "khwYaa_rawUl__eDtR8",
  "rawUl__kOyN0": "khwYaa_rawUl__kOyN0",
  "rawUl__qfoIg": "khwYaa_rawUl__qfoIg",
  "rawUl__x4JOz": "khwYaa_rawUl__x4JOz",
  "securityMeasuresYouCanTrust": "khwYaa_securityMeasuresYouCanTrust",
  "soc2TypeIiCertified": "khwYaa_soc2TypeIiCertified",
  "title": "khwYaa_title",
  "whyComplianceIsImportant": "khwYaa_whyComplianceIsImportant",
  "wrapper": "khwYaa_wrapper",
});
